// ─── FerMat — Application Constants ────────────────────────────
export const PASSING_SCORE          = 8;
export const QUIZ_TOTAL_QUESTIONS   = 10;
export const FEEDBACK_DELAY_MS      = 1500;
export const FLIP_DURATION_MS       = 500;
export const TOAST_DURATION_MS      = 2500;
export const MATCH_HIDE_DELAY_MS    = 800;
export const NEXT_CARD_DELAY_MS     = 300;
export const LEVENSHTEIN_THRESHOLD  = 2;
export const MAX_HINT_LEVEL         = 4;
export const LEITNER_KNOWN_BOX      = 2;
export const ANIMATION_STAGGER_MS   = 50;
export const SCROLL_TOP_THRESHOLD   = 200;
